import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiDialog-paper": {
      minHeight: "94vh",
      maxHeight: "94vh",
      minWidth: "90%",
      maxWidth: "90%",
    },
    "& .MuiDialogTitle-root": {
      backgroundColor: theme.palette.custom.main,
      color: "#fff",
      padding: "8px 20px",
    },
    "& .MuiDialogTitle-root+.MuiDialogContent-root ": {
      paddingTop: 20,
    },
    "& .MuiDialogContent-root": {
      padding: "20px 20px",
    },
    "& .MuiDialogActions-root": {
      paddingInlineEnd: 24,
    },
    "& .css-1foxyzl-MuiButtonBase-root-MuiTab-root": {
      fontSize: "13px",
    },
  },
  dialogTitleContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  title: {
    color: "#fff",
    fontWeight: "500",
  },
  closeIcon: {
    color: "#fff",
  },
  skipBtn: {
    "& .MuiButtonBase-root": {
      backgroundColor: "#e5e5e5",
      textTransform: "capitalize",
      color: "#000",
      borderRadius: 20,
      padding: "6px 20px",
      "&:hover": {
        backgroundColor: "#e5e5e5",
      },
      marginRight: "10px",
    },
  },
  closeBtn: {
    "& .MuiButtonBase-root": {
      backgroundColor: "#e5e5e5",
      textTransform: "capitalize",
      color: "#000",
      borderRadius: 20,
      padding: "6px 20px",
      "&:hover": {
        backgroundColor: "#e5e5e5",
      },
    },
  },
  submBtn: {
    "& .MuiButtonBase-root": {
      backgroundColor: "#0a0a0aff",
      textTransform: "capitalize",
      color: "#fff",
      borderRadius: 20,
      padding: "6px 20px",
      "&:hover": {
        color: "#000",
        backgroundColor: "#e5e5e5",
      },
    },
  },
  avatarContainer: {
    paddingBlockEnd: 12,
    display: "flex",
    gap: 12,
    flexWrap: "wrap",
    alignItems: "center",
    "& .MuiAvatar-root": {
      width: 64,
      height: 64,
    },
  },
  name: {
    "& .MuiTypography-root": {
      fontWeight: 600,
    },
  },
  detailsContainer: {
    paddingBlockEnd: 12,
  },
  detailsWrapper: {
    display: "flex",
    paddingBlock: 4,
  },
  key: {
    "& .MuiTypography-root": {
      width: 220,
    },
  },
  value: {
    "& .MuiTypography-root": {
      color: "#7a7272",
    },
  },
  wrapper: {
    paddingBlockEnd: 12,
  },
  container: {
    // boxShadow: "0px 5px 15px 5px rgb(0 0 0 / 10%)",
    padding: 0,
    borderRadius: 15,
    marginBlockEnd: 20,
    width: "100%",
  },
  label: {
    "& .MuiTypography-root": {
      color: "#d45a00",
    },
  },
  tabWrapper: {
    paddingBlock: 8,
    "& .MuiTab-root": {
      marginInlineEnd: 20,
      textTransform: "capitalize",
      padding: "12px 16px 12px 0px",
      fontSize: 16,
      fontWeight: 500,
      transition: "all ease .3s",
    },
    "& .MuiTabs-indicator": {
      height: 0,
    },
  },
  tableContainer: {
    paddingBlock: 20,
    "& .MuiDataGrid-root .MuiDataGrid-cell:focus-within": {
      outline: "none !important",
    },
    "& .MuiDataGrid-columnHeaders": {
      background: "#1D426D33",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: 700,
      textTransform: "uppercase",
      //   fontSize: 16,
    },
    "& .MuiDataGrid-iconSeparator ": {
      display: "none",
    },
    "& .MuiDataGrid-virtualScroller": {
      scrollbarWidth: "thin",
      "&::-webkit-scrollbar": {
        height: 6,
      },
    },
    "& .MuiDataGrid-footerContainer": {
      justifyContent: "flex-start",
    },
    "& .MuiTablePagination-selectLabel": {
      fontSize: 14,
    },
    "& .MuiTablePagination-displayedRows": {
      fontSize: 14,
    },
  },
  lightText: {
    "& .MuiTypography-root": {
      color: "rgba(0, 0, 0, 0.7)",
    },
  },
  header: {
    "& .MuiTypography-root": {
      fontSize: 20,
      paddingBlockEnd: 12,
      textTransform: "capitalize",
      color: theme.palette.custom.main,
    },
  },
  fieldWrapper: {
    margin: "20px 0px",
  },
  containerWrapper: {
    margin: "20px 10px",
  },
  textFieldWrapper: {
    paddingBottom: "20px",
    paddingRight: "30px",
  },
  sbtBtnWrapper: {
    display: "flex",
    justifyContent: "flex-end",
    padding: "10px 30px",
  },
  fileUploadWrapper: {
    border: "1px solid #dedede",
    borderRadius: "8px",
    marginRight: "30px !important",
    padding: "30px",
    marginBottom: "20px !important",
  },
  profilePicStyle: {
    width: "150px",
    height: "150px",
    objectFit: "cover",
    borderRadius: "50%",
  },
  avatarContainer: {
    width: "100%",
    height: 156,
    background: "#36577E33",
    borderRadius: 10,
    display: "flex",
    justifyContent: "center",
    position: "relative",
    marginBlockEnd: 116,
    [theme.breakpoints.down("sm")]: {
      height: 120,
      marginBlockEnd: 90,
    },
  },
  avatarWrapper: {
    position: "absolute",
    width: 170,
    height: 170,
    bottom: "-50%",
    [theme.breakpoints.down("lg")]: {
      width: 156,
      height: 156,
    },
    [theme.breakpoints.down("md")]: {
      width: 140,
      height: 140,
    },
    [theme.breakpoints.down("sm")]: {
      width: 120,
      height: 120,
    },
  },
  avatar: {
    width: "100%",
    height: "100%",
    border: "1px solid rgba(29, 66, 109, 0.5)",
    borderRadius: "100%",
    background: "#F3F3F3",
    position: "relative",
  },
  img: {
    width: "100%",
    height: "100%",
    borderRadius: "100%",
  },
  editIcon: {
    position: "absolute",
    right: -4,
    top: "61%",
    "& .MuiSvgIcon-root": {
      display: "flex",
      fontSize: 28,
      color: theme.palette.custom.main,
      cursor: "pointer",
    },
  },
  heading: {
    "& .MuiTypography-root": {
      fontWeight: 500,
      paddingBlockEnd: 20,
    },
  },
  fieldContainer: {
    display: "flex",
    flexWrap: "wrap",
    paddingBlock: 12,
    [theme.breakpoints.down("sm")]: {
      paddingBlock: 0,
    },
  },
  rightMargin: {
    marginInlineEnd: 40,
    [theme.breakpoints.down("sm")]: {
      marginInlineEnd: 0,
      paddingBlock: 12,
    },
  },
  padding: {
    [theme.breakpoints.down("sm")]: {
      paddingBlock: 12,
    },
  },
  btnWrapper: {
    display: "flex",
    justifyContent: "flex-end",
    paddingBlock: 12,
    "& .MuiButton-root": {
      padding: "6px 36px",
      backgroundColor: theme.palette.custom.main,
      textTransform: "capitalize",
      "&:hover": {
        backgroundColor: "#ec7905",
      },
    },
  },
  passengerProfileImageStyle: {
    objectFit: "cover",
  },
  dialogActions: {
    display: "flex",
  },
}));

export default useStyles;
